// import wikiImg from '../../image/wikipediaExternalPage.png'
import headshot from '../../image/gregHeadshot-50.png'
import funride from '../../lib/funride/funride.module.less'
export default function InnerPageHome () {
  return (
    <header>
      <h1>Fullstack Software Developer</h1>
      <p id={funride['pagehome-bio']}>
        {/* TODO - pull the copy directly from the Resume object */}
        <img alt='Photo of Greg Sandell' id={funride.headshot} src={headshot} />
          Frontend Javascript Engineer with emphasis on Node, Typescript and React.  I have been developing web-based applications and workflow tools in enterprise environments for almost 20 years.  I integrate quickly with teams and their methodologies to support existing legacy apps and internal UI libraries.  My recent work has been for banking, real estate, apparel e-commerce and entertainment clients.
      </p>
      <div>&nbsp;</div>
    </header>
  )
}
